import { IConfirmActionModal } from 'components/site/modals/ModalWrapper/ModalContent/contents/ConfirmActionModal';
import { EModal } from 'components/site/modals/ModalWrapper/ModalContent/useGetModalProperties';
import { ActionButton as ActionButton2 } from 'elements/minute/sidebar/sidebarComponents/atomic/ActionButton';
import { useContext } from 'react';
import { CtxDetail } from 'session/ctxDetail';
import { CtxModal } from 'session/ctxModal';
import styled from 'styled-components/macro';
interface Props {
    position: number;
    className?: string;
}

export const CardControl = (props: Props): JSX.Element => {
    const ctxDetail = useContext(CtxDetail);
    const ctxModal = useContext(CtxModal);

    function deleteCard() {
        ctxModal.setModal({
            type: EModal.CONFIRM,
            data: {
                text: 'Do you want to delete this card?',
                onConfirm: () => {
                    ctxDetail.deleteCardByPosition(props.position);
                }
            } as IConfirmActionModal
        });
    }

    function moveUp() {
        ctxDetail.moveCardByPosition(props.position, props.position - 1);
    }

    function moveDown() {
        ctxDetail.moveCardByPosition(props.position, props.position + 1);
    }

    if (ctxDetail.updatingIndex !== props.position) return <></>;

    return (
        <S_MinuteCardControl className={props.className}>
            {props.position > 0 && (
                <S_MinuteIcon icon={{ iconName: 'arrow-up' }} onClick={moveUp} />
            )}
            {props.position < ctxDetail.updateDetailInput.cards.length - 1 && (
                <S_MinuteIcon icon={{ iconName: 'arrow-down' }} onClick={moveDown} />
            )}
            <S_MinuteIcon icon={{ iconName: 'trash' }} onClick={deleteCard} />
        </S_MinuteCardControl>
    );
};

const S_MinuteCardControl = styled.div`
    display: flex;
    width: 100%;
    padding: 0 15px 0 0;
    justify-content: flex-end;
`;

const S_MinuteIcon = styled(ActionButton2)`
    margin: 10px 0 0 15px;
`;
